import {
  GET_WORKSPACE_DATA_REQUEST,
  GET_WORKSPACE_DATA_SUCCESS,
  GET_WORKSPACE_DATA_ERROR,
  UPDATE_WORKSPACE_DATA_REQUEST,
  UPDATE_WORKSPACE_DATA_SUCCESS,
  UPDATE_WORKSPACE_DATA_ERROR,
  UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST,
  UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS,
  UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR
} from "../actions/workspace";
import {
  ADD_USERS_TO_WORKSPACE_REQUEST,
  ADD_USERS_TO_WORKSPACE_SUCCESS,
  ADD_PROVIDERS_TO_WORKSPACE_REQUEST,
  ADD_PROVIDERS_TO_WORKSPACE_SUCCESS,
  ADD_PROVIDERS_TO_WORKSPACE_ERROR,
  REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST,
  REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS,
  REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR
} from "../actions/workspaces";

import {
  CREATE_INPUT_FILE_REQUEST,
  CREATE_INPUT_FILE_SUCCESS,
  CREATE_INPUT_FILE_ERROR,
  UPDATE_INPUT_FILE_REQUEST,
  UPDATE_INPUT_FILE_SUCCESS,
  UPDATE_INPUT_FILE_ERROR
} from "../actions/aegean_batch_inputs";

import { prependOrReplaceEntity } from "@utils/reducers";

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_WORKSPACE_DATA_REQUEST: {
      const { workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: true
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }
    case GET_WORKSPACE_DATA_SUCCESS: {
      const { workspace, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: workspace
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }
    case GET_WORKSPACE_DATA_ERROR: {
      const { error, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        error
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case UPDATE_WORKSPACE_DATA_REQUEST:
    case UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST:
    case ADD_PROVIDERS_TO_WORKSPACE_REQUEST:
    case REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST: {
      const { workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: true
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }
    case UPDATE_WORKSPACE_DATA_SUCCESS:
    case UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS:
    case ADD_PROVIDERS_TO_WORKSPACE_SUCCESS:
    case REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS: {
      const { workspace, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: {
          ...state[workspace_id].data,
          ...workspace
        }
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }
    case UPDATE_WORKSPACE_DATA_ERROR:
    case UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR:
    case ADD_PROVIDERS_TO_WORKSPACE_ERROR:
    case REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR: {
      const { error, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        error
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case ADD_USERS_TO_WORKSPACE_REQUEST: {
      const { workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: true
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }
    case ADD_USERS_TO_WORKSPACE_SUCCESS: {
      const { workspace, workspace_id } = action;

      if (!state[workspace_id] || !state[workspace_id].data) {
        /**
         * We may add users to workspace even if there is no workspace fetched.
         * In this case, we skip the update, because we have nothing to update.
         */
        return state;
      }

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        data: workspace
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case CREATE_INPUT_FILE_REQUEST: {
      const { workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: true
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case CREATE_INPUT_FILE_SUCCESS: {
      const newInput = action.data;
      const { workspace_id } = newInput;

      if (!state[workspace_id]) {
        return state;
      }

      const { data: workspace } = state[workspace_id];
      const newWorkspace = {
        ...workspace,
        aegean_batch_inputs: prependOrReplaceEntity(workspace.aegean_batch_inputs, newInput)
      };

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        data: newWorkspace
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case CREATE_INPUT_FILE_ERROR: {
      const { error, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        error
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case UPDATE_INPUT_FILE_REQUEST: {
      const { workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: true
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case UPDATE_INPUT_FILE_SUCCESS: {
      const updatedInput = action.data;
      const { workspace_id } = updatedInput;

      if (!state[workspace_id]) {
        return state;
      }

      const { data: workspace } = state[workspace_id];
      const newWorkspace = {
        ...workspace,
        aegean_batch_inputs: prependOrReplaceEntity(workspace.aegean_batch_inputs, updatedInput)
      };

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        data: newWorkspace
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case UPDATE_INPUT_FILE_ERROR: {
      const { error, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        error
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    default: return state;
  }
};
